import { DeleteEmployeeParams } from 'types/services';
import { asyncTimeout } from 'utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from 'utils/constants';

export const deleteEmployee = async (
  params: DeleteEmployeeParams
): Promise<void> => {
  await asyncTimeout(SERVICES_MOCK_DELAY);
};
